import { useState } from "react";
import HeroPolicy from "@/components/common/HeroPolicy";
import Container from "@/components/layout/Container";

type TabType = "site" | "location";

const Terms = () => {
  const [activeTab, setActiveTab] = useState<TabType>("site");

  return (
    <Container>
      <HeroPolicy />

      <main id="main-content" className="min-h-screen">
        <div className="py-[2rem] sm:py-[4rem]">
          {/* Tabs */}
          <nav className="mb-16 flex justify-center px-[2rem]">
            <ul
              className="flex flex-col sm:flex-row gap-3 sm:gap-4 m-0 list-none w-full sm:w-auto"
              role="tablist"
            >
              <li className="w-full sm:w-auto">
                <button
                  role="tab"
                  aria-selected={activeTab === "site"}
                  onClick={() => setActiveTab("site")}
                  className={`px-8 py-3 text-[1.6rem] font-bold transition-all rounded-full cursor-pointer ${
                    activeTab === "site"
                      ? "bg-[#494e54] text-white shadow-md"
                      : "bg-[#f1f3f5] text-[#494e54] hover:bg-gray-200"
                  }`}
                >
                  사이트 이용약관
                </button>
              </li>
              <li>
                <button
                  role="tab"
                  aria-selected={activeTab === "location"}
                  onClick={() => setActiveTab("location")}
                  className={`px-8 py-3 text-[1.6rem] font-bold transition-all rounded-full cursor-pointer ${
                    activeTab === "location"
                      ? "bg-[#494e54] text-white shadow-md"
                      : "bg-[#f1f3f5] text-[#494e54] hover:bg-gray-200"
                  }`}
                >
                  위치기반서비스 이용약관
                </button>
              </li>
            </ul>
          </nav>

          {/* Content */}
          <div className="policy-content px-[2rem] wide:px-0">
            {activeTab === "site" ? (
              <div>
                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">제 1장</h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 1조 목적</h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    이 약관은 스탠다드 네트웍스(주)가 제공하는 문자메세지 서비스(이하 "서비스"라
                    합니다)의 이용조건 및 절차에 관한 사항과 기타 필요 사항을 규정함을 목적으로
                    합니다.
                  </p>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 2조 약관의 효력과 변경</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      본 약관은 전기통신사업법 규정에 의하여 제정한 것이며 공시함으로써 효력을
                      발생합니다. 본 약관의 공시는 스탠다드 네트웍스(주) 서비스
                      홈페이지(www.standardnetworks.co.kr)에 게시하는 방법으로 합니다.
                    </li>
                    <li>
                      관계법령의 제·개정 및 정부정책의 변경, 스탠다드 네트웍스(주)의 합리적인 사정
                      변경의 경우와 영업상 중요 사유가 있을 때 약관을 개정할 수 있습니다.
                    </li>
                    <li>
                      본 약관의 적용기간은 고객이 서비스 이용계약을 신청한 때부터 서비스 해지(또는
                      해제) 후 정산이 완료될 때까지로 규정합니다. 다만, 서비스 종류별 약관적용
                      기간을 별도 공지한 경우에는 예외로 합니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 3조 약관 외 준칙</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      본 약관은 스탠다드 네트웍스(주)가 제공하는 서비스에 관하여 별도의 정책 및 운영
                      규칙과 함께 적용됩니다.
                    </li>
                    <li>
                      본 약관에서 정하지 아니한 사항에 관하여는 별도의 이용계약서, 관계 법령 또는
                      상관례에 따릅니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 4조 용어의 정의</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      고객(신청자) : 서비스 이용계약의 당사자로 스탠다드 네트웍스(주)에 서비스
                      이용신청서를 제출하고 이용요금의 납부의무를 가진 법인이나 개인
                    </li>
                    <li>
                      고객 아이디 : 서비스이용시 서비스 이용계약자의 고유한 번호로 가입자당 1개만
                      부여합니다.
                    </li>
                    <li>
                      요금 납입자 : 요금청구서(세금계산서)가 발생하는 단위로 서비스 이용계약
                      당사자와 동일함을 원칙으로 하고, 다만 계약시 필요에 따라 다수의 (고객)신청자를
                      포함할 수 있습니다.
                    </li>
                    <li>
                      해지 : 스탠다드 네트웍스(주) 또는 고객(신청자)가 서비스 개통 후 서비스
                      이용계약을 해약하는 것
                    </li>
                    <li>
                      해제 : 스탠다드 네트웍스(주) 또는 고객(신청자)가 서비스 개통 전 서비스
                      이용계약을 해약하는 것
                    </li>
                    <li>
                      중지 : 스탠다드 네트웍스(주) 또는 고객(신청자)가 일정기간 서비스 이용을 제한
                      또는 유보하는 것으로 최대 1개월을 넘기지 못합니다.
                    </li>
                    <li>
                      개통일 : 고객(신청자)이 서비스를 신청한 후 스탠다드 네트웍스(주)가 고객이
                      서비스를 이용할 수 있도록 필요한 조치를 완료한 일자
                    </li>
                    <li>
                      변경일 : 고객(신청자)이 서비스 내용에 대한 변경을 요청한 후 스탠다드
                      네트웍스(주)가 고객의 요청 사항들을 조치하여 완료한 일자
                    </li>
                    <li>
                      해지/해제일 : 스탠다드 네트웍스(주) 또는 고객(신청자)가 이미 신청한 서비스의
                      이용(이용 전) 종료를 요청 또는 통보한 일자
                    </li>
                    <li>
                      불법통신 : 음란한 내용, 비방, 허위사실에 의한 타인 명예훼손, 불법복제 등
                      지적재산권침해, 국가기밀 침해, 청소년보호법상 청소년 유해 매체물 등을 포함한
                      통신
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">제 2장 서비스 계약</h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 5조 계약의 성립</h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    이용계약은 서비스 이용을 원하는 고객(이하 "고객"이라 합니다)의 청약(서비스 사용
                    계약서 및 관련 서류의 제출)과 스탠다드 네트웍스(주)의 개통작업이 완료된 시점에
                    성립합니다.
                  </p>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 6조 서비스의 이용신청</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>스탠다드 네트웍스(주)는 고객에게 서비스 이용약관을 사전에 공지합니다.</li>
                    <li>
                      고객은 다음 각 호의 서류를 직접 또는 우편이나 기타 스탠다드 네트웍스(주)가
                      인정하는 방식 (우편 또는 온라인 신청 등)으로 스탠다드 네트웍스(주)에
                      제출하여야 합니다.
                      <ul className="pl-6 mt-2 space-y-2 list-disc">
                        <li>고객의 서비스 사용 계약서 (소정양식)</li>
                        <li>고객의 사업자등록증</li>
                        <li>발신번호 변작방지 및 사전등록 동의서 (소정양식)</li>
                        <li>발신번호 사전등록 대리인 등록 신청서 / 위임장 (소정양식)</li>
                        <li>기타 이와 부대하는 증명,증빙자료</li>
                      </ul>
                    </li>
                    <li>
                      고객이 민법상 미성년자, 한정치산자 또는 금치산자인 경우는 서비스 신청이
                      불가합니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 7조 서비스 개통 및 개통거부
                  </h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      스탠다드 네트웍스(주)는 고객에 대하여 업무 수행상 또는 기술상 지장이 없는
                      경우에 접수 순서에 따라 서비스를 개통합니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 다음 각 호에 해당하는 경우 개통을 거부할 수 있습니다.
                      <ul className="pl-6 mt-2 space-y-2 list-disc">
                        <li>본인의 실명을 사용하지 않고, 타인의 명의로 신청한 경우</li>
                        <li>
                          이용신청서의 내용을 허위로 기재하였거나 허위의 서류를 첨부하여 신청한 경우
                        </li>
                        <li>
                          음란물 또는 이적물의 배포·전시 및 타인의 저작권을 침해하거나, 침해할
                          가능성이 있는 경우
                        </li>
                        <li>불법스팸을 발송하여 이용계약이 해지된 후 1년이 경과하지 않은 경우</li>
                      </ul>
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 8조 계약의 해지</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      서비스 해지를 희망하는 고객은 해지 희망일 기준 20일전까지 스탠다드
                      네트웍스(주)에 서면으로 해지의사를 통보해야 합니다.
                    </li>
                    <li>
                      고객의 해지요청에 따라 서비스가 해지된 후 발생된 고객정보 소실에 대한 책임은
                      고객에게 있으며, 스탠다드 네트웍스(주)에 이로 인한 손해배상을 청구할 수
                      없습니다.
                    </li>
                    <li>
                      정보통신망법, 개인정보보호법 및 제반 법령에서 금지하는 행위를 할 목적으로
                      서비스를 이용하거나, 금지행위에 서비스가 제공되는 경우 본 서비스계약이 해지될
                      수 있습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">
                    제 3장 서비스 이용 및 이용제한
                  </h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 9조 서비스 이용</h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    스탠다드 네트웍스(주)는 고객이 서비스 이용에 필요한 다음 각 호의 사항을
                    공지하여야 합니다.
                  </p>
                  <ul className="list-disc pl-6 mt-2 space-y-2 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>고객지원(이용, 요금, 장애처리 등) 연락처</li>
                    <li>정기/비정기 점검 실시계획, 기타 서비스에 영향을 줄 수 있는 작업</li>
                  </ul>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 10조 이용의 제한</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      스탠다드 네트웍스(주)는 국가비상사태, 서비스 설비의 장애 또는 서비스 이용의
                      폭주 등으로 서비스 이용에 지장이 있을 때에는 서비스의 전부 또는 일부를
                      제한하거나 정지할 수 있습니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 고객의 서비스 이용 내용이 이용제한 사항에 해당될
                      경우에는, 이에 대한 소명 및 개선을 요구할 수 있으며, 이행되지 않을 경우 접속
                      호 축소, 1개월간 서비스 이용을 제한하거나 영구적으로 정지할 수 있습니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 서비스 이용제한 기간 중 발생한 요금은 고객에게
                      청구하지 않습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">제 4장 의무와 책임</h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 11조 ID/비밀번호 관리</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>고객의 ID와 비밀번호에 관한 관리책임은 고객에게 있습니다.</li>
                    <li>
                      고객은 자신의 ID 및 개인정보가 타인에 의해 무단 이용되는 경우 즉시 스탠다드
                      네트웍스(주)에 통보해야 합니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 제반의 고객관리 업무를 고객 ID에 의해서 수행합니다.
                    </li>
                    <li>
                      고객은 이용 ID를 공유, 양도 또는 변경할 수 없습니다. 단 그 사유가 인정되는
                      경우에는 스탠다드 네트웍스(주)에 통보하여 승낙을 얻어야 합니다.
                    </li>
                    <li>
                      실명이나 실제 정보를 입력하지 않은 고객은 법적인 보호를 받을 수 없으며 서비스
                      제한 조치를 받을 수 있습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 12조 스탠다드 네트웍스(주)의 의무
                  </h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      스탠다드 네트웍스(주)는 특별한 사정이 없는 한 고객이 신청한 서비스 개통
                      희망일에 서비스를 이용할 수 있도록 합니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 업무상, 기술상 지장이 없는 한 연중무휴(24*365)
                      서비스를 제공합니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 고객으로부터 제기되는 의견이나 불만이 정당하다고
                      인정할 경우에는 즉시 처리하여야 합니다.
                    </li>
                    <li>
                      스탠다드 네트웍스(주)는 서비스 제공과 관련하여 취득한 이용고객의 정보를 본인의
                      사전 승낙 없이 타인에게 누설 또는 배포할 수 없습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 13조 고객의 의무</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      고객은 서비스 이용에 대한 대가로서 본 약관 또는 서비스 이용계약에서 정한
                      요금을 납입할 의무가 있습니다.
                    </li>
                    <li>
                      고객은 서비스 신청당시의 고객정보에 변경이 발생하면 즉시 그 내용을 스탠다드
                      네트웍스(주)에 통보하여야 합니다.
                    </li>
                    <li>
                      고객이 스탠다드 네트웍스(주)의 설비를 분실 또는 훼손하였거나 장애를 초래하게
                      하였을 경우에는 그 손해를 전액 부담하여야 합니다.
                    </li>
                    <li>
                      고객은 사전 승낙 없이 상업적인 목적(SPAM)을 위하여 서비스를 이용할 수
                      없습니다.
                    </li>
                  </ol>
                </section>
              </div>
            ) : (
              <div>
                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">제 1장 총칙</h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 1조 목적</h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    이 약관은 스탠다드네트웍스(주)(이하 "회사")가 제공하는 위치기반서비스(이하
                    "서비스")에 관한 이용조건 및 절차 등 기본적인 사항을 규정함을 목적으로 합니다.
                  </p>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 2조 약관의 효력 및 변경</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      본 약관은 서비스를 이용하고자 하는 모든 고객에 대하여 그 효력을 발생합니다.
                    </li>
                    <li>
                      회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 이 약관을 변경할 수
                      있습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 3조 서비스 가입자격</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      서비스에 가입할 수 있는 자는 위치정보 수집이 가능한 이동전화 단말기를 보유하고
                      있는 자로서, 실명 및 고유정보 확인 절차를 거친 개인 또는 법인 고객입니다.
                    </li>
                    <li>
                      법인 명의의 이동전화를 사용하는 고객은 법인의 사업자번호를 사용하여 서비스에
                      가입할 수 있습니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 4조 서비스 가입</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      회사가 정한 본 약관에 고객이 동의하고, 회사가 승낙함으로써 서비스 가입의
                      효력이 발생합니다.
                    </li>
                    <li>
                      회사는 다음 각 호의 고객 가입신청에 대해서는 이를 승낙하지 아니할 수 있습니다.
                      <ul className="pl-6 mt-2 space-y-2 list-disc">
                        <li>실명이 아니거나 다른 사람의 명의를 사용하는 등 허위로 신청하는 경우</li>
                        <li>고객 등록 사항을 누락하거나 오기하여 신청하는 경우</li>
                        <li>공공질서 또는 미풍양속을 저해하거나 저해할 목적으로 신청한 경우</li>
                        <li>기타 회사가 정한 이용신청 요건이 충족되지 않았을 경우</li>
                      </ul>
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 5조 서비스의 해지</h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    서비스 해지를 희망하는 고객은 회사가 정한 소정의 절차(유무선인터넷 홈페이지 등을
                    통해 공지합니다)를 통해 서비스 해지를 신청할 수 있습니다.
                  </p>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 6조 서비스의 수준</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다. 단, 회사의 업무상이나
                      기술상의 이유로 서비스가 일시 중지될 수 있습니다.
                    </li>
                    <li>위치정보는 관련 기술의 발전에 따라 오차가 발생할 수 있습니다.</li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">제 2장 서비스 이용</h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 7조 서비스 이용의 제한 및 정지
                  </h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8] mb-3">
                    회사는 고객이 다음 각 호에 해당하는 경우 사전 통지 없이 고객의 서비스 이용을
                    제한 또는 정지하거나 직권 해지를 할 수 있습니다.
                  </p>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>다른 사람의 명의(주민등록번호) 등을 이용하여 서비스에 가입한 경우</li>
                    <li>타인의 서비스 이용을 방해하거나 타인의 개인정보를 도용한 경우</li>
                    <li>서비스를 이용하여 법령, 공공질서, 미풍양속 등에 반하는 행위를 한 경우</li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">제 8조 서비스의 변경 및 중지</h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      회사는 다음 각 호의 1에 해당하는 경우 고객에게 서비스의 전부 또는 일부를 제한,
                      변경하거나 중지할 수 있습니다.
                      <ul className="pl-6 mt-2 space-y-2 list-disc">
                        <li>서비스용 설비의 보수 등 공사로 인한 부득이한 경우</li>
                        <li>
                          정전, 제반 설비의 장애 또는 이용 량의 폭주 등으로 정상적인 서비스 이용에
                          지장이 있는 경우
                        </li>
                        <li>
                          서비스 제휴업체와의 계약 종료 등과 같은 회사의 제반 사정 또는 법률상의
                          장애 등으로 서비스를 유지할 수 없는 경우
                        </li>
                        <li>기타 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</li>
                      </ul>
                    </li>
                    <li>
                      제1항에 의한 서비스 중단의 경우에는 회사는 인터넷 등에 공지하거나 고객에게
                      통지합니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h2 className="text-[2rem] font-bold text-navy mb-6">
                    제 3장 개인위치정보의 보호
                  </h2>
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 9조 고객의 개인위치정보보호
                  </h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    회사는 관련법령이 정하는 바에 따라서 고객의 개인위치정보를 보호하기 위하여
                    노력합니다.
                  </p>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 10조 개인위치정보의 이용 또는 제공
                  </h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      회사는 서비스 제공을 위하여 고객의 위치정보를 이용할 수 있으며, 고객은 본
                      약관에 동의함으로써 이에 동의한 것으로 간주됩니다.
                    </li>
                    <li>
                      회사는 고객이 제공한 개인위치정보를 당해 고객의 동의 없이 서비스 제공 이외의
                      목적으로 이용하지 아니합니다.
                    </li>
                    <li>
                      회사는 고객이 제공한 개인위치정보를 당해 고객의 동의 없이 제3자에게 제공하지
                      아니합니다.
                    </li>
                    <li>
                      회사는 고객의 개인위치정보를 고객이 지정하는 제3자에게 제공할 경우 매회
                      고객에게 제공받는 자, 제공 일시 및 제공목적을 이동전화 문자메시지(SMS)를 통해
                      고객의 이동전화 단말기로 즉시 통보합니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 11조 개인위치정보 이용·제공사실 확인자료의 보유
                  </h3>
                  <ol className="list-decimal pl-6 space-y-3 text-[1.5rem] text-gray-6 leading-[1.8]">
                    <li>
                      회사는 위치 정보의 보호 및 이용 등에 관한 법률 제 16조 2항에 근거하여 고객에
                      대한 위치정보 이용·제공사실 확인자료를 위치정보시스템에 자동으로 기록하며,
                      고객불만 응대를 위하여 기록시점으로부터 6개월간 보존합니다.
                    </li>
                    <li>
                      회사는 위치 정보의 보호 및 이용 등에 관한 법률 제 24조 4항의 규정에 의하여
                      고객이 동의의 전부 또는 일부를 철회한 경우에는 지체 없이 수집된 개인위치정보
                      및 위치정보 이용제공사실 확인자료를 파기합니다.
                    </li>
                  </ol>
                </section>

                <section className="mb-10">
                  <h3 className="text-[1.8rem] font-semibold mb-4">
                    제 12조 개인위치정보의 보유기간 및 이용기간
                  </h3>
                  <p className="text-[1.5rem] text-gray-6 leading-[1.8]">
                    회사는 고객의 개인위치정보를 이용한 경우 위치 정보의 보호 및 이용 등에 관한 법률
                    제 16조 2항의 규정에 의하여 기록 보존하여야 하는 위치정보이용 제공사실 확인자료
                    외의 당해 개인위치정보를 고객이 동의한 목적범위내에서의 이용 및 고객불만 응대를
                    위하여 3개월간 보유하며 3개월이 지난 경우 지체 없이 파기합니다.
                  </p>
                </section>
              </div>
            )}
          </div>
        </div>
      </main>
    </Container>
  );
};

export default Terms;
